import React, { useEffect } from 'react';
import { useFormik } from 'formik';

import { Button, Modal, Text } from 'v3/components';
import DatePicker from 'v3/components/DatePicker';
import { toApiDate } from 'v3/utils/rntrcValidation';

import { emissionStartDateSchema } from './validator';

export default function EmissionStartDateModal({ show, onClose, onConfirm }) {
  const formik = useFormik({
    initialValues: { emissionStartDate: '' },
    validationSchema: emissionStartDateSchema,
    validateOnBlur: false,
    onSubmit: async (values, { setFieldError }) => {
      const result = await onConfirm(toApiDate(values.emissionStartDate));
      if (result?.fieldError) setFieldError('emissionStartDate', result.fieldError);
    },
  });

  useEffect(() => {
    if (!show) formik.resetForm();
  }, [show]);

  return (
    <Modal
      show={show}
      handleClose={formik.isSubmitting ? undefined : onClose}
      heading={
        <Text color="dark" type="header" weight="500">
          Aprovar cadastro no sistema de emissão
        </Text>
      }
      body={
        <form
          onSubmit={(event) => {
            event.preventDefault();
            formik.handleSubmit();
          }}
        >
          <DatePicker
            guide
            label="Início emissão contra CT-e *"
            name="emissionStartDate"
            value={formik.values.emissionStartDate}
            onChange={formik.handleChange}
            error={formik.submitCount > 0 ? formik.errors.emissionStartDate : undefined}
            disabled={formik.isSubmitting}
            data-testid="emission-start-date-input"
          />
          <Text type="little" color="gray" as="p" className="mt-2">
            A partir das 00:00 desta data (horário de Brasília), a solicitação passa para Emitindo
            Contra CT-e. Se a transportadora já tiver data de início, a data gravada é mantida. A
            data pode ser alterada depois nos dados da transportadora.
          </Text>
        </form>
      }
      footer={
        <div className="d-flex justify-content-end" style={{ gap: '0.75rem' }}>
          <Button variant="white" outlined disabled={formik.isSubmitting} onClick={onClose}>
            <Text weight={500} type="regular">
              Cancelar
            </Text>
          </Button>
          <Button
            variant="success"
            onClick={formik.handleSubmit}
            loading={formik.isSubmitting}
            data-testid="emission-confirm"
          >
            <Text weight={500} color="white" type="regular">
              Aprovar
            </Text>
          </Button>
        </div>
      }
    />
  );
}
